import {IonicModule} from '@ionic/angular';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TabsPageRoutingModule} from './regisafe-routing.module';
import {RegisafePage} from './regisafe.page';
import {RegisafeDirectiveModule} from '../directives.module';


@NgModule({
	imports: [
		IonicModule,
		CommonModule,
		FormsModule,
		TabsPageRoutingModule,
		RegisafeDirectiveModule
	],
	exports: [
		RegisafePage
	],
	declarations: [RegisafePage]
})
export class TabsPageModule {
}
